import React, {useContext} from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";

import {addNewObjectBtnStyles} from "../styles/header.styles";
import AddIcon from '@material-ui/icons/Add';

import {UserContext} from "core/context/user";
import {AppRoutes} from "core/helpers/app-routes";
import {UserRoles} from "core/enums";
import {UtilsContext} from "core/context/utils.context";
import { ButtonGrow } from "components";
import { flattenArtifactList } from "core/export/export-flat";
import { CollectorCollectionApi } from "core/api";
import { exportZipForList } from "core/export/export";
import { IArtifactFlat } from "core/export/export-flat";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

export const AddNewObjectBtn: React.FC = () => {

    const userContext = useContext(UserContext);
    const utilsContext = useContext(UtilsContext);

    const history = useHistory();

    const classes = addNewObjectBtnStyles();

    const goToAddObject = (): void => {
        switch(userContext.user?.role) {
            case UserRoles.COLLECTOR:
                history.push(AppRoutes.ADD_OBJECT);
                break;
            case UserRoles.ARCHIVIST:
                history.push(`${AppRoutes.ADD_OBJECT}?jobId=${utilsContext.selectedJob}`);
                break;
            case UserRoles.CURATOR:
                history.push(`${AppRoutes.ADD_OBJECT}?jobId=${utilsContext.selectedJob}`);
                break;
        }
    }

    const exportObjects = async (): Promise<void> => {
        if(!userContext.user?.id) {
            return;
        }

        try {
            const res = await CollectorCollectionApi.getCollectionItemsForExport(userContext.user.id);
            const flat: IArtifactFlat[] = res.data.map((artifact: any) => flattenArtifactList(artifact));
            await exportZipForList(flat, 'artifacts');
        } catch (error: any) {
            console.error(error.response);
        }
    };

    return (
        <>
        {userContext.user?.role !== UserRoles.ARCHIVIST && (
            <span style={{marginRight: 10}}>
                <ButtonGrow
                    icon={<CloudDownloadIcon className="export-icon" />}
                    text={'Export'}
                    id={'export-object-btn'}
                    onClick={() => {
                        void exportObjects();
                    }}
                />
            </span>
        )}
         
        <Button
            id="go-to-new-object-btn"
            variant="contained"
            color="primary"
            className={classes.root}
            onClick={() => goToAddObject()}
        >
            <AddIcon className={classes.icon} />
            <span className={classes.hideXS}>Add new object</span>
        </Button>
        </>
    )
}
